import { SET_SCHOOL_ID } from './school-id-actions';

const defaultState = null;

/**
 * School ID Reducer
 *
 * Consumes SET_SCHOOL_ID action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {number} - the school id
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case SET_SCHOOL_ID:
        return action.payload;

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/overview/school-id-reducer.js